/**
    * @description      : 
    * @author           : 
    * @group            : 
    * @created          : 16/05/2025 - 14:30:35
    * 
    * MODIFICATION LOG
    * - Version         : 1.0.0
    * - Date            : 16/05/2025
    * - Author          : 
    * - Modification    : 
**/
import React, { useEffect, useState } from "react";
import { auth } from "../../firebase";
import { api } from "../../api/data"; // Import your API service

const ShowToken: React.FC = () => {
  const [firebaseToken, setFirebaseToken] = useState<string | null>(null);
  const [apiToken, setApiToken] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchTokens = async () => {
      setLoading(true);
      setError(null);
      
      try {
        // Get Firebase ID token
        if (auth.currentUser) {
          const idToken = await auth.currentUser.getIdToken();
          setFirebaseToken(idToken);
          
          // Get API token using our service
          const accessToken = await api.getCurrentToken();
          setApiToken(accessToken);
        } else {
          setError("No user logged in");
        }
      } catch (error) {
        console.error("Error fetching tokens:", error);
        setError("Failed to fetch tokens");
      } finally {
        setLoading(false);
      }
    };

    fetchTokens();
  }, [auth.currentUser]);

  // Function to test API endpoint access
  const testApiAccess = async () => {
    try {
      // Test call to elevation endpoint
      const result = await api.getElevation(48.932100, 9.521008);
      alert("API call successful: " + JSON.stringify(result));
    } catch (error) {
      console.error("API test failed:", error);
      alert("API call failed. See console for details.");
    }
  };

  if (loading) {
    return <div>Loading tokens...</div>;
  }

  if (error) {
    return <div className="text-danger">{error}</div>;
  }

  return (
    <div className="container mt-4">
      <div className="card">
        <div className="card-header bg-primary text-white">
          <h3>Authentication Information</h3>
        </div>
        <div className="card-body">
          <div className="mb-3">
            <h4>User Information</h4>
            <p><strong>Name:</strong> {auth.currentUser?.displayName || "Not available"}</p>
            <p><strong>Email:</strong> {auth.currentUser?.email || "Not available"}</p>
            <p><strong>User ID:</strong> {auth.currentUser?.uid || "Not available"}</p>
          </div>
          
          <div className="mb-3">
            <h4>Firebase ID Token</h4>
            <div className="input-group">
              <input 
                type="text" 
                className="form-control" 
                value={firebaseToken ? `${firebaseToken.substring(0, 20)}...` : "No token"} 
                readOnly 
              />
              <button 
                className="btn btn-outline-secondary" 
                onClick={() => {
                  if (firebaseToken) {
                    navigator.clipboard.writeText(firebaseToken);
                    alert("Firebase token copied to clipboard!");
                  }
                }}
              >
                Copy Full Token
              </button>
            </div>
            <small className="text-muted">This token is exchanged for an API token</small>
          </div>
          
          <div className="mb-3">
            <h4>API Access Token</h4>
            <div className="input-group">
              <input 
                type="text" 
                className="form-control" 
                value={apiToken ? `${apiToken.substring(0, 20)}...` : "No token"} 
                readOnly 
              />
              <button 
                className="btn btn-outline-secondary" 
                onClick={() => {
                  if (apiToken) {
                    navigator.clipboard.writeText(apiToken);
                    alert("API token copied to clipboard!");
                  }
                }}
              >
                Copy Full Token
              </button>
            </div>
            <small className="text-muted">This token is used for API access</small>
          </div>
          
          <button 
            className="btn btn-success mt-3" 
            onClick={testApiAccess}
            disabled={!apiToken}
          >
            Test API Access
          </button>
        </div>
      </div>
    </div>
  );
};

export default ShowToken;